export default {
  props: {
    scrollY: Number,
  },
  data() {
    return {
      isDoodleActive: false,
      cursor: null
    };
  },
  mounted() {
    this.initAnimation();
    this.$on('loco-scroll-update', this.handleLocoScrollUpdate);
    window.addEventListener('resize', this.checkIfMobile);
  },
  beforeDestroy() {
    this.$off('loco-scroll-update', this.handleLocoScrollUpdate);
    window.removeEventListener('resize', this.checkIfMobile);
  },
  methods: {
    handleLocoScrollUpdate() {
      this.moveCircle();
    },
    initAnimation() {
      this.cursor = this.$refs.cursor;
      const page = this.$refs.clickableContainer;
      const followArea = this.$el.querySelectorAll('.area-clickable');

      this.checkIfMobile();

      if (!this.$device.isMobile) {
        page.addEventListener('mousemove', (e) => {
          this.clientY = e.clientY;
          this.clientX = e.clientX;

          if (!this.isDoodleActive) {
            this.moveCircle();
          }
        });

        followArea.forEach((el) => {
          el.addEventListener('mouseover', () => {
            if (!this.isDoodleActive) {
              this.$gsap.to(this.cursor, {
                duration: 0.25,
                scale: 1,
                autoAlpha: 1,
              });
            }
          });

          el.addEventListener('mouseout', () => {
            this.$gsap.to(this.cursor, {
              duration: 0.25,
              scale: 0.5,
              autoAlpha: 0,
            });
          });

          el.addEventListener('mousedown', () => {
            this.$gsap.to(this.cursor, {
              duration: 0.5,
              css: {
                translate: '-50%, -50%',
                scale: 0.75
              },
            });
          });

          el.addEventListener('mouseup', () => {
            this.$gsap.to(this.cursor, {
              duration: 0.5,
              css: {
                translate: '-50%, -50%',
                scale: 1
              },
            });
          });
        });
      }
    },
    checkIfMobile() {
      const isMobile = this.$device.isMobile || (window.innerWidth <= 640);
      const button = this.$refs.doodleTrigger;

      // Remove all existing event listeners
      button.removeEventListener("touchstart", this.handleTouchStart);
      button.removeEventListener("mouseover", this.handleMouseOver);
      button.removeEventListener("mouseout", this.handleMouseOut);

      if (isMobile) {
        button.addEventListener("touchstart", this.handleTouchStart);
      } else {
        button.addEventListener("mouseover", this.handleMouseOver);
        button.addEventListener("mouseout", this.handleMouseOut);
      }
    },
    handleTouchStart(e) {
      e.stopPropagation();
      e.preventDefault();
      this.handleDoodleMouseEvent(e, !this.isDoodleActive);
    },
    handleMouseOver(e) {
      if (e) {
        e.stopPropagation();
      }
      this.handleDoodleMouseEvent(e, true);
    },
    handleMouseOut(e) {
      if (e) {
        e.stopPropagation();
      }
      this.handleDoodleMouseEvent(e, false);
    },
    moveCircle() {
      if (!this.isDoodleActive) {
        this.$gsap.to(this.cursor, {
          duration: 0.15,
          left: this.clientX,
          top: this.scrollY + this.clientY,
        });
      }
    },
    handleDoodleMouseEvent(e, enter) {
      const doodle = this.$refs.doodle;
      this.isDoodleActive = enter;

      if (!this.$device.isMobile) {
        this.$gsap.to(this.cursor, {
          duration: 0.25,
          opacity: enter ? 0 : 1,
        });

        this.moveCircle();
      }

      this.$gsap.to(doodle, {
        duration: 0.25,
        opacity: enter ? 1 : 0,
      });
    }
  },
};
